export const MULTIMEDIA_CLEANED = {
  _key: "",
  type: "",
  category: "",
  name: "",
  multimediaPath: "",
  fieldName: ""
};

export const PARAMETER_CLEANED = {
  id: "",
  name: "",
  editable: false
};

export const MULTIMEDIA_MANAGER_CONSTANTS = {
  NO_FOUND_FILES_MESSAGES: "No se encontraron archivos",
  SEND_FILE: "sendFile",
  SELECT_MULTIMEDIA_FILE: "Seleccionar archivo multimedia",
  LOADING_LIST: "Cargando lista...",
  SELECT_VALUE: "Seleccione valor",
  NO_FILES: "No hay archivos para seleccionar.",
  CANCEL: "Cancelar",
  ACCEPT: "Aceptar",
  SELECT_FILE: "Seleccione archivo",
  DISABLED_VIEW_ICON: " append-icon-disabled",
  TYPE: "Tipo",
  CATEGORY: "Categoría"
};
